var path = '/pages/picklists/views/picklists/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/picklists/list.tpl.html
// module id = 2303
// module chunks = 1